import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import amber from '@material-ui/core/colors/amber';
import red from '@material-ui/core/colors/red';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import NavPills from "components/NavPills/NavPills.js";
import Parallax from "components/Parallax/Parallax.js";
import Personal from "components/Personal/index.js";
import Contact from "components/Contact/index.js";
import Educations from "components/Educations/index.js";
import Skills from "components/Skills/index.js";
import Links from "components/Links/index.js";
import Resume from "components/Resume/index.js";
import Jobs from "components/Jobs/index.js";
import Projects from "components/Projects/index.js";
import History from "components/History/index.js";
import Honors from "components/Honors/index.js";
import ChangePassword from "components/ChangePassword/index.js";
import Chip from '@material-ui/core/Chip';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import profile from "assets/img/faces/men.png";
import Link from '@material-ui/core/Link';
import download from "downloadjs"
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import BeatLoader from "react-spinners/BeatLoader";

import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import styles from "assets/jss/material-kit-react/views/profilePage.js";
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'


const useStyles = makeStyles(styles);

export default function ProfilePage(props) {

  const classes = useStyles();
  const { ...rest } = props;

  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgCube,
    classes.imgProfile
  );

  const [user, setUser] = useState(null);
  const [events, setEvents] = useState(null);
  const [loading, setLoading] = useState(true);

  const [load, setLoad] = React.useState(false);
  const [profileImage, setProfileImage] = React.useState(null);
  const imageUploader = React.createRef(null)

  const downloadResumeFile = () => {
    
    Axios.get(Config.api + "Resume/GetResumeFile",
      {
        responseType: "blob",
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then(async (result) => {
        download(result.data, 'Resume.pdf');
        swal.close()
        swal("فایل با موفقیت ایجاد شد.", {
          icon:"success"
        })
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status === 422)
          swal("پارامترهای وارد شده نادرست است");
        else if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          return props.history.push("/");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const downloadResume = () => {
    swal("در حال ساخت پیوند اشتراک گذاری؛ لطفا شکیبا باشید ...", {
      buttons: false,
      icon:"info",
      closeOnEsc: false,
      closeOnClickOutside: false,
    })
    Axios.post(Config.api + "Resume/ManageResumeLink",{

    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then(async (result) => {
        var url="http://sharifcamp.ir/u/r/"+result.data.data.code
        var span = document.createElement("span");
span.innerHTML = "<a target='_blank' href='"+url+"' style='direction:ltr; text-algin:left; color:#999 !important' class='swal-content__input' disabled >"+url+"</a>";
    swal({
      text: 'جهت اشتراک گذاری رزومه، میتوانید از لینک زیر استفاده کنید.',
      content: span,
      buttons: {
        cancel: "برگشت",
        copy: {
          text: "کپی کردن",
          value: "copy",
          closeModal: false,
        },
        download: {
          text: "دانلود فایل",
          value: "download",
          closeModal: false,
        },
      },
    }).then((result) => {
      if(result=="copy"){
        navigator.clipboard.writeText(url);
         swal("کپی شد.", {
          buttons: false,
          timer: 1000,
          icon:"success"
        })
      }
      else if(result=="download"){
        downloadResumeFile();
      }
    })
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status === 422)
          swal("پارامترهای وارد شده نادرست است");
        else if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          return props.history.push("/");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const logOut = () => {
    localStorage.clear();
    props.history.push("/SignIn");
  }

  var Call = (base64) => {
    return new Promise((resolve, reject) => {
      Axios.post(Config.api + "Authentication/UpdateProfilePicture", {
        picture: base64
      },
        {
          headers: {
            apikey: Config.apikey,
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        }).then((result) => {
          swal({
            title: "موفق",
            text: "تصویر جدید جایگزین شد.",
            icon: "success",
          })
          resolve()
        }).catch((err) => {
          if (err && err.response && err.response.status && err.response.status == 422)
            swal("پارامترهای ارسالی نادرست است.");
          else if (err && err.response && err.response.data && err.response.data.fa_message) {
            swal(err.response.data.fa_message);
          }
          else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
            swal(err.response.data.message.pr);
          else swal("خطایی رخ داده است.")
          reject();
        })
    })
  }
  var GetEvents = () => {
    return new Promise((resolve, reject) => {
      Axios.post(Config.api + "Now/GetAll", {
        tags: ["Event", "Course"]
      },
        {
          headers: {
            apikey: Config.apikey,
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        }).then((result) => {
          setEvents(result.data.data)
          setLoading(false)
          resolve()
        }).catch((err) => {
          if (err && err.response && err.response.status && err.response.status == 422)
            swal("پارامترهای ارسالی نادرست است.");
          else if (err && err.response && err.response.data && err.response.data.fa_message) {
            swal(err.response.data.fa_message);
          }
          else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
            swal(err.response.data.message.pr);
          else swal("خطایی رخ داده است.")
          reject();
        })
    })
  }
  function resizeBase64Img(image, newWidth, newHeight) {
    return new Promise((resolve, reject) => {
      var canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      var cw = canvas.width;
      var ch = canvas.height;
      var img = new Image;
      img.onload = function () {
        var iw = img.width;
        var ih = img.height;
        var scale = Math.min((newWidth / iw), (newHeight / ih));
        var iwScaled = iw * scale;
        var ihScaled = ih * scale;
        canvas.width = iwScaled;
        canvas.height = ihScaled;
        context.drawImage(img, 0, 0, iwScaled, ihScaled);
        resolve(canvas.toDataURL())
      }
      img.src = URL.createObjectURL(image);



    });
  }
  const fileChanged = (e) => {
    var file = e.target.files[0];
    resizeBase64Img(file, 160, 160).then((base64) => {
      if (base64.length > 200000)
        return swal('فایل بزرگتر از حد مجاز است.');

      swal({
        title: "مطمئنید؟",
        text: "تصویر جدید جایگزین خواهد شد.",
        icon: "warning",
        buttons: {
          cancel: {
            text: "خیر",
            value: false,
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "بله",
            value: true,
            visible: true,
            closeModal: false
          }
        }
      }).then((yes) => {
        if (yes)
          Call(base64).then(() => {
            setProfileImage(base64)
          });

      })
    });
  }

  const uploadImage = () => {
    imageUploader.current.click();
  }
  const bull = <span className={classes.bullet}>•</span>;
  var Me = (base64) => {
    return new Promise((resolve, reject) => {
      Axios.post(Config.api + "Authentication/Me", {
      },
        {
          headers: {
            apikey: Config.apikey,
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        }).then(async (result) => {
          if (result.data.data.me.registered == false)
            return props.history.push("/Complete");
          setUser(result.data.data.me);
        localStorage.setItem('level', result.data.data.me.level);
          setLoad(true);
          resolve();
        }).catch((err) => {
          if (err && err.response && err.response.status && err.response.status === 422)
            swal("پارامترهای وارد شده نادرست است");
          else if (err && err.response && err.response.status && err.response.status === 401) {
            localStorage.removeItem('token');
            return props.history.push("/");
          }
          else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
            swal(err.response.data.message.pr);
          else swal("خطایی رخ داده است.")
          reject();
        })
    })
  }
  useEffect(() => {
    Me().then(() => {
      GetEvents();
    })
  }, []);
  var i = 0;
  var j = 0;
  if (load)
    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "white"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/profile-bg.jpg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.profile}>
                    <div>
                      <img src={profileImage == null ? ((user.picture == null) ? profile : user.picture) : profileImage} alt="..." className={imageClasses} />
                    </div>
                    <div className={classes.name}>
                      <div >
                        <span className={classes.profileImageEditButton}>
                          <Link className={classes.white} href="#" onClick={uploadImage}>
                            <span className={classes.fileUploader}>
                              <input
                                type="file"
                                accept=".png,.jpg"
                                ref={imageUploader}
                                onChange={fileChanged}
                              />
                            </span>
                            <i className="material-icons">edit</i></Link>
                        </span>

                      </div>
                      <h5>{user.name}</h5>
                      <h6>
                        {user.phoneNumber} (
                        <Link href="#" onClick={logOut}>
                          خروج
                        </Link>
                        )
                      </h6>

                      {/*}
                      <Button justIcon link className={classes.margin5}>
                        <i className={"fab fa-twitter"} />
                      </Button>
                      <Button justIcon link className={classes.margin5}>
                        <i className={"fab fa-instagram"} />
                      </Button>
                      <Button justIcon link className={classes.margin5}>
                        <i className={"fab fa-facebook"} />
                      </Button>
                      <Button justIcon link className={classes.margin5}>
                        <i className={"fab fa-linkedin"} />
                      </Button>
                      <br />
                      */}
                    </div>

                  </div>

                  <div className={classes.scoreBox}>
                    <Chip
                      icon={<StarBorderIcon style={{ color: "white" }} />}
                      style={{ color: "white", backgroundColor: amber[500] }}
                      label={((!user.siteScore) ? 0 : user.siteScore) + " امــــــتـیــاز"}
                    />
                  </div>
                  <div className={classes.downloadResume}>
                    <Chip
                      icon={<CloudDownloadIcon style={{ color: "white" }} />}
                      style={{ color: "white", backgroundColor: red[500] }}
                      label={"دریافت رزومه"}
                      onClick={downloadResume}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <NavPills
                    disableRipple
                    color="primary"
                    alignCenter={true}
                    tabs={[
                      /*{
                        tabButton: "دوره‌های آموزشی",
                        tabContent: (
                          <div className={classes.container + " " + classes.direction}>
                            <GridContainer justify="center">
                              <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.fastAccess}>
                                  دوره‌های فعال  <Button href='/Courses' variant="contained" className={classes.other} size="small" disableElevation>نمایش همه دوره‌ها</Button>
                                  <br />
                                  <br />
                                  <BeatLoader color={"gray"} loading={loading} size={15} />
                                  <GridContainer justify="left">

                                  {events && events.map((event, index) => {
                                    if (event.tags.indexOf("Course") != -1) {
                                      j++;
                                      return (
                                          <GridItem xs={12} sm={12} md={3}>
                                            <Card variant="outlined" className={classes.card}>
                                              <CardActionArea>
                                                <CardMedia
                                                  component="img"
                                                  alt={event.title}
                                                  height="140"
                                                  src={event.cover}
                                                  title={event.title}
                                                />
                                                <CardContent>
                                                  <div className={classes.cardtitle} >
                                                  <Typography gutterBottom variant="button">
                                                    {event.title}
                                                  </Typography>
                                                  <Typography variant="caption" className={classes.description}  display="block" gutterBottom>
                                                    {event.summary}
                                                  </Typography>
                                                  </div>
                                                  
                                                </CardContent>
                                              </CardActionArea>
                                              <CardActions>
                                                <div className={classes.left}>
                                                  <Button href={event.link} size="small" color="primary">
                                                    {event.linkTitle ? event.linkTitle : "نمایش"}
                                                  </Button>
                                                </div>
                                              </CardActions>
                                            </Card>
                                          </GridItem>
                                      )
                                    }
                                    if(index==events.length-1&&j==0){
                                      return (
                                        <div >
                                          دوره فعال وجود ندارد.
                                        </div>
                                      )
                                    }
                                  })}
                                  
                                        </GridContainer>

                                </div>
                              </GridItem>

                            </GridContainer>
                          </div>
                        )
                      },*/
                      {
                        tabButton: "رویدادها و مسابقات",
                        tabContent: (
                          <div className={classes.container + " " + classes.direction}>
                            <GridContainer justify="center">
                              <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.fastAccess}>
                                  رویدادهای فعال
                                  <br />
                                  <br />

                                  <BeatLoader color={"gray"} loading={loading} size={15} />
                                        <GridContainer justify="left">

                                  {events && events.map((event, index) => {
                                    if (event.tags.indexOf("Event") != -1 || event.tags.indexOf("Course") != -1) {
                                      i++;
                                      return (
                                          <GridItem xs={12} sm={12} md={3}>
                                            <Card variant="outlined" className={classes.card}>
                                              <CardActionArea>
                                                <CardMedia
                                                  component="img"
                                                  alt={event.title}
                                                  height="140"
                                                  src={event.cover}
                                                  title={event.title}
                                                />
                                                <CardContent>
                                                  <Typography className={classes.cardtitle} gutterBottom variant="button">
                                                    {event.title}
                                                  </Typography>
                                                  <Typography className={classes.justify} variant="body2" color="textSecondary" component="p">
                                                  </Typography>
                                                  <Typography variant="caption" display="block" gutterBottom>
                                                    {event.summary}
                                                  </Typography>
                                                </CardContent>
                                              </CardActionArea>
                                              <CardActions>
                                                <div className={classes.left}>
                                                  <Button href={event.link} size="small" color="primary">
                                                    {event.linkTitle ? event.linkTitle : "نمایش"}
                                                  </Button>
                                                </div>
                                              </CardActions>
                                            </Card>
                                          </GridItem>



                                      )
                                    }
                                    if(index==events.length-1&&i==0){
                                      return (
                                        <div >
                                          رویداد فعال وجود ندارد.
                                        </div>
                                      )
                                    }
                                  })}
                                        </GridContainer>

                                </div>
                              </GridItem>
                            </GridContainer>
                          </div>
                        )
                      },
                      {
                        tabButton: "ثبت نام‌های شما",
                        tabContent: (
                          <div className={classes.container + " " + classes.direction}>
                            <GridContainer justify="center">
                              <GridItem xs={12} sm={12} md={12}>
                                <span><History order="DESC" user={user}></History></span>
                              </GridItem>
                            </GridContainer>
                          </div>
                        )
                      },
                      {
                        tabButton:"اطلاعات شخصی و رزومه",
                        tabContent:(
                          <div className={classes.direction}>
                          <NavPills
                          disableRipple
                          color="rose"
                          alignCenter={true}
                          tabs={[
                            /*{
                              tabButton: "دریافت رزومه",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <span><Resume user={user}></Resume></span>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },*/
                            {
                              tabButton: "اطلاعات شخصی",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <span><Personal changeName={(name) => {
                                        let n = Object.assign({}, user);
                                        n.name = name
                                        setUser(n);
                                      }} user={user}></Personal></span>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                            {
                              tabButton: "اطلاعات تماس",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <span><Contact user={user}></Contact></span>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                            {
                              tabButton: "سوابق تحصیلی",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <div><Educations user={user}></Educations></div>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                            {
                              tabButton: "مهارت‌ها",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <div><Skills user={user}></Skills></div>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                            {
                              tabButton: "سوابق شغلی",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <div><Jobs user={user}></Jobs></div>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                            {
                              tabButton: "پروژه‌ها",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <div><Projects user={user}></Projects></div>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                            {
                              tabButton: "افتخارات",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <span><Honors user={user}></Honors></span>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                            {
                              tabButton: "لینک‌ها",
                              tabContent: (
                                <div className={classes.container + " " + classes.direction}>
                                  <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={12}>
                                      <span><Links user={user}></Links></span>
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              )
                            },
                          ]}
                            />
                            </div>
                        )
                      },
                      {
                        tabButton: "تغییر رمز عبور",
                        tabContent: (
                          <div className={classes.container + " " + classes.direction}>
                            <GridContainer justify="center">
                              <GridItem xs={12} sm={12} md={12}>
                                <span><ChangePassword user={user}></ChangePassword></span>
                              </GridItem>
                            </GridContainer>
                          </div>
                        )
                      }
                    ]}

                  />
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  else
    return (<div></div>)
}
